/* @flow */
import * as React from "react";
import { lighten } from "polished";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import NoStyleButton from "nx-components/NoStyleButton";
import { simpleActiveBackgroundColor } from "nx-components/Tappable";
import prefixStyles from "nx-components/utils/prefixStyles";
import { IconDeletePinpad } from "nx-components/Icons";
import touchHandlersFromClickHandlers from "nexia_mobile/components/utils/touchHandlersFromClickHandlers";

const DISABLED_LIGHTEN_AMOUNT = 0.3;

type KeyProps = {
  onClick?: ?() => void,
  children?: ?React.Node,
  disabled?: ?boolean,
  colors: ColorSet,
};

type KeyState = {
  isActive: boolean,
};

class KeyWithoutColors extends React.Component<KeyProps, KeyState> {
  state = {
    isActive: false,
  };

  _handleClick = () => {
    const { onClick } = this.props;
    if (onClick != null) {
      onClick();
    }
  };

  _handleDown = () => {
    this.setState({ isActive: true });
  };

  _handleUp = () => {
    this.setState({ isActive: false });
  };

  _handlers = touchHandlersFromClickHandlers(
    this._handleClick,
    this._handleDown,
    this._handleUp
  );

  render() {
    const { children, disabled, colors } = this.props;
    const isActive = this.state.isActive && !disabled;

    const styles = prefixStyles({
      button: {
        borderRadius: "50%",
        height: "2.3em",
        maxWidth: "2.3em",
        flex: "1 1 100%",
        fontSize: "1.5em",
        padding: "0.5em",
        backgroundColor: simpleActiveBackgroundColor(isActive),
        color: disabled
          ? lighten(DISABLED_LIGHTEN_AMOUNT, colors.TEXT)
          : colors.TEXT,
      },
    });

    return (
      <NoStyleButton {...this._handlers} style={styles.button}>
        {children}
      </NoStyleButton>
    );
  }
}

const Key = withColorsProvider(KeyWithoutColors);

type Props = {
  onKeypad: (digit: string) => void,
  isTablet?: ?boolean,
  disabled?: ?boolean,
};

class PivotKeyboard extends React.Component<Props> {
  render() {
    const { isTablet, disabled, onKeypad } = this.props;

    const styles = prefixStyles({
      keypadRow: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-around",
        lineHeight: "1.5em",
        maxHeight: "3.5em",
        padding: "0.5em",
        fontSize: isTablet ? "1.25em" : "",
        border: "1px  solid #929ba2",
      },
      keypadBorder: {
        border: "1px  solid #929ba2",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
      },
      keypadDivider: {
        height: "2.3em",
        flex: "1 1 100%",
        fontSize: "1.5em",
        maxWidth: "2px",
        borderLeft: "2px  solid #929ba2",
      },
      keypad: {
        flex: "1 1 auto",
        padding: "1em",
        width: "100%",
        maxWidth: "25em",
        display: "flex",
        alignItems: "stretch",
        justifyContent: "space-around",
        flexDirection: "column",
      },
      deletePinpadIcon: {
        fontSize: "1.2em",
      },
    });

    return (
      <div style={styles.keypad}>
        <div style={styles.keypadBorder}>
          <div style={styles.keypadRow}>
            <Key disabled={disabled} onClick={() => onKeypad("1")}>
              1
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("2")}>
              2
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("3")}>
              3
            </Key>
          </div>
          <div style={styles.keypadRow}>
            <Key disabled={disabled} onClick={() => onKeypad("4")}>
              4
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("5")}>
              5
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("6")}>
              6
            </Key>
          </div>
          <div style={styles.keypadRow}>
            <Key disabled={disabled} onClick={() => onKeypad("7")}>
              7
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("8")}>
              8
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("9")}>
              9
            </Key>
          </div>
          <div style={styles.keypadRow}>
            <Key disabled />
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("0")}>
              0
            </Key>
            <div style={styles.keypadDivider} />
            <Key disabled={disabled} onClick={() => onKeypad("backspace")}>
              <IconDeletePinpad style={styles.deletePinpadIcon} />
            </Key>
          </div>
        </div>
      </div>
    );
  }
}

export default PivotKeyboard;



// WEBPACK FOOTER //
// ./src/components/PinEntry/PivotKeyboard.jsx